import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import {
    listDecryptedConsigneeForPrint,
    ListDecryptedConsigneeResult,
    postLogOrderDecryptConsigneeByPlatformApi,
} from "@/services/api/order";
import PddOrderDecryptor from "@/services/PddOrderDestpytor";
import ListDecryptedConsigneeError from "@/services/utils/ListDecryptedConsigneeError";
import type GlobalStore from "@/store";

/**
 * 批量解密订单收货地址
 * 未处理 跨店铺情况，如遇跨店铺，请进行 shopId分组
 */
export default async function batchOrderDecryptedConsignee(orders: OrderDTO[], globalStore: typeof GlobalStore) {
    const results: ListDecryptedConsigneeResult[] = [];

    const shopId = orders[0].shopId;
    const shop = globalStore.shopMapping.get(shopId);

    if (shop.type === ShopType.PINDUODUO) {
        for (let i = 0; i < orders.length; i++) {
            const order = orders[i];

            const decryptor = new PddOrderDecryptor(order);

            const result = await decryptor.decrypt();

            if (!result.successful) {
                console.error("pdd 解密失败", result);

                if (!result.isOriginalAddressDecryptForbidden || !result.data) {
                    throw new ListDecryptedConsigneeError("", ShopType.PINDUODUO, result);
                }
            }

            await postLogOrderDecryptConsigneeByPlatformApi(shopId, [
                {
                    id: order.id,
                    originalId: order.originalId,
                    mergeSplitStatus: order.mergeSplitStatus,
                },
            ]);

            results.push({
                id: order.id,
                consignee: {
                    ...result.data.consignee,
                    privacyProtection: result.data.privacyProtection,
                    virtualIdentifyNo: result.data.virtualIdentifyNo,
                },
            });
        }
    } else {
        const resultChunks = await listDecryptedConsigneeForPrint({ shopId, orders });

        results.push(...resultChunks);
    }

    return results;
}
